"use client";

import ProductCardListBySearchTabClient from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/ProductCardListBySearchTabClient";
import type { ProductCardListBySearchTabProps } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";
import useFeatureFlag from "@/lib/feature-flags/hooks/useFeatureFlag";
import ProductCardTabsAndPillsByUUIDClient from "./ProductCardTabsAndPillsByUUIDClient";
import type { ProductCardTabsAndPillsByUUIDProps } from "./types";

function toSearchTabProps(
  props: ProductCardTabsAndPillsByUUIDProps,
): ProductCardListBySearchTabProps {
  const { title, className, categories, location, cardFormatSubtype } = props;
  return { title, className, categories, location, cardFormatSubtype };
}

/**
 * Resolves `NEXT_PUBLIC_FEATURE_HOMEPAGE_TRENDING_COURSE_UPDATE` on the client (env + API),
 * then renders the search-tab trending UI when `test`, otherwise the UUID pills/accordion UI.
 */
export default function ProductCardTabsAndPillsByUUIDFeatureBranch(
  props: ProductCardTabsAndPillsByUUIDProps,
) {
  const { flagValue } = useFeatureFlag(
    "NEXT_PUBLIC_FEATURE_HOMEPAGE_TRENDING_COURSE_UPDATE",
    "legacy",
  );

  if (flagValue === "test") {
    return <ProductCardListBySearchTabClient {...toSearchTabProps(props)} />;
  }

  return <ProductCardTabsAndPillsByUUIDClient {...props} />;
}
